var map = {
	"./Chevron_left.svg": 3523,
	"./Initial_avatar.svg": 6716,
	"./Lock_light.svg": 1640,
	"./Logo.svg": 2273,
	"./Logo_icon.svg": 1247,
	"./Mail.svg": 4161,
	"./User.svg": 6349,
	"./View_hide.svg": 3258,
	"./View_show.svg": 177,
	"./add.svg": 6613,
	"./alert_error.svg": 8301,
	"./alert_success.svg": 7678,
	"./chevron-down.svg": 498,
	"./chevron-left.svg": 8921,
	"./circle-information.svg": 6185,
	"./close.svg": 3360,
	"./collection.svg": 3728,
	"./document-download.svg": 5200,
	"./download.svg": 932,
	"./edit.svg": 3992,
	"./empty-font-preview.svg": 3572,
	"./marker-tip.svg": 8162,
	"./search.svg": 7584,
	"./shield.svg": 2759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6066;